module.exports = __webpack_public_path__ + "img/swipe1.b9c5399a.png";